import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router'
import {SharedService} from '../../services/shared.service'
import {Product} from '../../models/product'

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {
  products: Product[] = []
  protected readonly Number = Number;

  constructor(
    private router: Router,
    public shared: SharedService,
  ) {
    this.shared.blockRefresh()
    this.products = this.shared.products
  }

  ngOnInit(): void {
  }

  onContract(product: Product): void {
    this.shared.product = product
    this.router.navigateByUrl('/terms-and-conditions')
  }
}
